const createState = () => ({
  messages: [],
  toolMessage: '',
  currentAgent: null,
});

export default createState;
